var chunkToChildrenMap = {"852960":["553727","843712","13640","609948","558868","84385","530195","366270","113039","613629","544385","723860","217826","459217","458968","958273","924034","478329","660626","455807","194250","63728"]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};